import { Money } from "../common/money";

export type Attribute = {
    id:string;
    label: string;
    isRequired: boolean;
    isEnabled?: boolean;
    isHidden?: boolean;
    fieldType?: FieldType;
    displayOrder?: number;
    //toggle
    defaultState?: boolean;

    //text, text description, number
    placeholderText?: string;
    isLimited?: boolean;
    maxLengthLimit?: number;

    //file uplaod
    maxSizeLimit?: number;
    fileExtensionTypes?: FileExtensionType[];
    fileSize?: number;

    //time
    isIncludeTimeInformation?: boolean,
    is24hFormat?: boolean

    //dropdown
    isSingleType?: boolean,
    childrenOptionDefinitions?: Option[],

    minNumberValue?: number;
    maxNumberValue?: number;
    RegularExpression?: string;
};

export enum FieldType {
    Text = 1,
    Number = 2,
    Bool = 3,
    Dropdown = 4,
    ConditionalDropdown = 5,
    ChildDropdown = 6,
    DateTime = 7,
    SingleSelect = 8,
    MultiSelect = 9,
    TextDescription = 10,
    File = 11,
    Image = 12
}

export function getFieldTypeString(fieldType : FieldType){
    switch (fieldType) {
            case FieldType.Text : return "Text" 
            case FieldType.Number : return "Number" 
            case FieldType.Bool : return "Toggle" 
            case FieldType.Dropdown : return "Dropdown" 
            case FieldType.ConditionalDropdown : return "Conditional Dropdown" 
            case FieldType.ChildDropdown : return "Child Dropdown" 
            case FieldType.DateTime : return "Date and Time" 
            case FieldType.SingleSelect : return "Single Select" 
            case FieldType.MultiSelect : return "Multi Select" 
            case FieldType.TextDescription : return "Text Description" 
            case FieldType.File : return "File Upload" 
            case FieldType.Image : return "Image" 
    }
}


export enum FileExtensionType {
    JPG = 1,
    JPEG = 2,
    PNG = 3,
    MP4 = 4,
    DOC = 5,
    DOCX = 6,
    PDF = 7,
    CSV = 8,
}
export function getFileExtensionTypeString(fileExtensionType : FileExtensionType){
    switch (fileExtensionType) {
        case FileExtensionType.JPG : return "JPG"
        case FileExtensionType.JPEG : return "JPEG"
        case FileExtensionType.PNG : return "PNG"
        case FileExtensionType.MP4 : return "MP4"
        case FileExtensionType.DOC : return "DOC"
        case FileExtensionType.DOCX : return "DOCX"
        case FileExtensionType.PDF : return "PDF"
        case FileExtensionType.CSV : return "CSV"
    }
}


export type Option = {
    id?: string,
    value: string,
    displayOrder?: number,
    childOptions?: Option[],
    price?: Money,
};